<template>
	<div class="modal fade" :id="modal.selector" data-keyboard="false" tabindex="-1" role="dialog" aria-hidden="true">
		<div class="modal-dialog" role="document">
			<div class="modal-content">
				<div class="modal-header">
					<div class="btn-toolbar pull-right" role="toolbar">
						<div class="btn-group" role="group" aria-label="...">
							<button type="button" class="close" data-dismiss="modal" aria-label="Close">
								<span aria-hidden="true">&times;</span>
							</button>
						</div>
					</div>
					<h4  class="modal-title">Editar commentario</h4>
				</div>
				<div class="modal-body">
					<div class="row">
						<div class="col-md-12">
							<div class="form-group">
								<textarea v-model="comment.content" class="form-control" cols="30" rows="10" maxlength="500"></textarea>
							</div>
						</div>
					</div>
				</div>
				<div class="modal-footer">
					<button
						ref="btnStore"
						@click="update()"
						type="button"
						class="btn btn-success">Actualizar</button>
					<button type="button" class="btn btn-default" data-dismiss="modal">Cancelar</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import swal from 'sweetalert2'
	import Ladda from 'ladda'

	export default {
		props: ['user', 'isAuth', 'resource'],
		data () {
			return {
				modal: {
					selector: 'model-comments-edit',
				},
				comment: {
					content: null,
					type: 'timeline',
					username: null,
					email: null,
					parent_id: null,
				}
			}
		},
		methods: {
			open(comment) {
				this.comment = comment
				var modal = $('#'+this.modal.selector)
				modal.modal('show')
			},
			close() {
				var modal = $('#'+this.modal.selector)
				modal.modal('hide')
			},
			clearData() {
				this.comment.content = null
				this.comment.username = null
				this.comment.email = null
				this.comment.parent_id = null
			},
			update() {
				if(this.comment.content) {
					var loading = Ladda.create(this.$refs.btnStore)
					loading.start()
					this.$http.post(this.resource + '/comment/' + this.comment.id + '/edit', this.comment)
					.then(response => {
						loading.stop()
						this.$emit('reload')
						this.close()
						this.clearData()
						swal({
							title: response.body.title,
							text: response.body.text,
							type: response.body.type,
						})
					}).catch(function(response) {
						loading.stop()
						console.log(response)
						this.$emit('reload')
						swal({
							title: response.statusText,
							text: response.body,
							type: "warning",
						})
					})
				}
			},
		}
	}	
</script>


// WEBPACK FOOTER //
// src/components/cms/comments/views/Edit.vue